import React, { useState, useEffect } from 'react';
import { Container } from 'react-bootstrap';
import './gallery.css';

// Import images
import img1 from '../../assets/foto/DSC03225-Migliorato-NR.JPG';
import img2 from '../../assets/foto/DSC03278-Migliorato-NR.JPG';
import img3 from '../../assets/foto/DSCF0842.JPG';
import img4 from '../../assets/foto/GATE-1.jpg';
import img5 from '../../assets/foto/GATE-114.jpg';
import img6 from '../../assets/foto/GATE-52.jpg';
import img7 from '../../assets/foto/GATE-65.jpg';
import img8 from '../../assets/foto/GATE-72.jpg';
import img9 from '../../assets/foto/GATE-74.jpg';

const Gallery = () => {
    const images = [img1, img2, img3, img4, img5, img6, img7, img8, img9];
    const [currentSlide, setCurrentSlide] = useState(0);
    const [isMobile, setIsMobile] = useState(false);

    // Detect mobile screen size
    useEffect(() => {
        const checkMobile = () => {
            setIsMobile(window.innerWidth < 768);
        };

        checkMobile();
        window.addEventListener('resize', checkMobile);

        return () => window.removeEventListener('resize', checkMobile);
    }, []);

    // Auto-scroll
    useEffect(() => {
        const interval = setInterval(() => {
            setCurrentSlide((prev) => {
                const slidesPerView = isMobile ? 1 : 3;
                const totalSlides = Math.ceil(images.length / slidesPerView);
                return (prev + 1) % totalSlides;
            });
        }, 3000);

        return () => clearInterval(interval);
    }, [isMobile, images.length]);

    const slidesPerView = isMobile ? 1 : 3;
    const totalSlides = Math.ceil(images.length / slidesPerView);

    return (
        <section className="gallery-section" style={{ padding: '80px 0', backgroundColor: '#f8f9fa', overflow: 'hidden' }}>
            <Container>
                <h2 style={{ textAlign: 'center', fontSize: '2.5rem', marginBottom: '60px', fontWeight: 'bold' }}>
                    GALLERY
                </h2>
                <div className="gallery-slider">
                    <div
                        className="gallery-track"
                        style={{
                            transform: `translateX(-${currentSlide * 100}%)`,
                            transition: 'transform 0.5s ease-in-out'
                        }}
                    >
                        {Array.from({ length: totalSlides }).map((_, slideIndex) => (
                            <div key={slideIndex} className="gallery-slide">
                                {images
                                    .slice(slideIndex * slidesPerView, (slideIndex + 1) * slidesPerView)
                                    .map((img, imgIndex) => (
                                        <div key={imgIndex} className="gallery-item">
                                            <img src={img} alt={`Gallery ${slideIndex * slidesPerView + imgIndex + 1}`} />
                                        </div>
                                    ))}
                            </div>
                        ))}
                    </div>
                </div>
                <div className="gallery-dots" style={{ textAlign: 'center', marginTop: '30px' }}>
                    {Array.from({ length: totalSlides }).map((_, index) => (
                        <span
                            key={index}
                            className={`dot ${currentSlide === index ? 'active' : ''}`}
                            onClick={() => setCurrentSlide(index)}
                            style={{
                                display: 'inline-block',
                                width: '12px',
                                height: '12px',
                                borderRadius: '50%',
                                backgroundColor: currentSlide === index ? '#1a1a1a' : '#ccc',
                                margin: '0 5px',
                                cursor: 'pointer',
                                transition: 'background-color 0.3s'
                            }}
                        />
                    ))}
                </div>
            </Container>
        </section>
    );
};

export default Gallery;
